/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./bootstrap";
import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./components/shop/App.vue";
import Toast from "vue-toastification";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import LoadingAlert from "./components/layout/LoadingAlert.vue";
import Progressbar from "./components/layout/Progressbar.vue";
import NotFound from "./components/layout/NotFound.vue";
import LoadMore from "./components/layout/LoadMore.vue";
import NetworkError from "./components/layout/NetworkError.vue";
import router from "./router/shop";
import Auth from "./composables/shop/auth";
import VueSelect from "vue-select";
window.axios.defaults.baseURL = window.APP_URL + "/api/shop/";
window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (Auth.check())
        window.toast.error(window.i18n["Your Token has expired"]);
      Auth.removeUser();
      router.push({ name: "login" });
    } else if (error.response?.status === 422 && error.response?.data?.errors)
      window.toast.error(window.getErrors(error)[0]);
    return Promise.reject(error);
  }
);

// if ("serviceWorker" in navigator) {
//   window.deferredPrompt = null;
//   navigator.serviceWorker
//     .register(window.APP_URL + "/serviceworker.js", {
//       scope: "/app",
//     })
//     .then(
//       (registration) => {
//         window.addEventListener("beforeinstallprompt", (event) => {
//           event.preventDefault();
//           window.deferredPrompt = event;
//           return false;
//         });
//       },
//       (err) => {
//         console.log("Laravel PWA: ServiceWorker registration failed: ", err);
//       }
//     );
// }

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const options = {
  position: "bottom-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  toastClassName: "!rounded-[8px]",
  containerClassName: "!mb-16 lg:!mb-0",
  rtl: true,
  maxToasts: 3,
};
const app = createApp(App);
const head = createHead();
//   setSentry(app);
app.config.globalProperties.__ = (str) => _.get(window.i18n, str);

app.config.globalProperties.auth = Auth;
const featuresDisabled = window.nikran?.features_disabled || [];
app.config.globalProperties.featureEnabled = function(feature) {
    return !featuresDisabled.includes(feature)
}

app.component("v-select", VueSelect);
//   app.config.errorHandler = (err) => axios.post('error',{message: err.stack});
app.component("PulseLoader", PulseLoader);
app.component("Progressbar", Progressbar);
app.component("LoadingAlert", LoadingAlert);
app.component("NotFound", NotFound);
app.component("NetworkError", NetworkError);
app.component("LoadMore", LoadMore);
app.use(router).use(head).use(Toast, options).mount("#app");

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
